<template>
<zm-dialog
  class="zone-detail-dialog"
  :class="isIframesModal ? 'opc-modal-dialog' : ''"
  top="8vh"
  :visible.sync="visible"
  :show-close="!isIframesModal"
  @close="handleCancel">
  <!--header-->
  <NavBack v-if="isIframesModal" :backHandler="handleCancel" class="mb24" slot="title" />
  <img :src="logo" alt="" class="zone-detail-dialog__logo" v-if="planCategory !== ZOOM_MEETING_SUB_TYPES.EDUCATION">
  <h1 class="zone-detail-dialog__title" :class="planCategory !== ZOOM_MEETING_SUB_TYPES.EDUCATION ? 'zone-text-upper' : ''">{{ planCategoryName }}</h1>
  <div class="zone-detail-dialog__price">
    <price-list :plan-category="defaultPlanCategory" :unit-type="planUnitMap.user"/>
  </div>
  <FeatureULForPro v-if="planCategory === ZOOM_MEETING_SUB_TYPES.PRO" :onEssentialAppLearnMore="onEssentialAppLearnMore" :onAICompanionLearnMore="onAICompanionLearnMore" :onTasksLearnMore="onTasksLearnMore" :on-work-flow-learn-more="onWorkFlowLearnMore" :on-drive-learn-more="onDriveLearnMore" :onCustomAvatarLearnMore="onCustomAvatarLearnMore" />
  <FeatureULForBiz v-if="planCategory === ZOOM_MEETING_SUB_TYPES.BIZ" :onEssentialAppLearnMore="onEssentialAppLearnMore" :onAICompanionLearnMore="onAICompanionLearnMore" :onTasksLearnMore="onTasksLearnMore" :on-work-flow-learn-more="onWorkFlowLearnMore" :on-drive-learn-more="onDriveLearnMore" :onCustomAvatarLearnMore="onCustomAvatarLearnMore" :isEnableBizPriceIncrease="isEnableBizPriceIncrease" />
  <FeatureULForProPlus
    v-if="planCategory === ZOOM_MEETING_SUB_TYPES.PRO_PLUS"
    :onEssentialAppLearnMore="onEssentialAppLearnMore"
    :onAICompanionLearnMore="onAICompanionLearnMore"
    :onVisitorManagementLearnMore="onVisitorManagementLearnMore"
    :onCustomAvatarLearnMore="onCustomAvatarLearnMore"
    :onTasksLearnMore="onTasksLearnMore"
    :showStartingPrice="false"
    :startingPrice="$money(annualPriceNum * 10)"
  />
  <FeatureULForBizPlus
    v-if="planCategory === ZOOM_MEETING_SUB_TYPES.BIZ_PLUS"
    :onEssentialAppLearnMore="onEssentialAppLearnMore"
    :onAICompanionLearnMore="onAICompanionLearnMore"
    :onVisitorManagementLearnMore="onVisitorManagementLearnMore"
    :onCustomAvatarLearnMore="onCustomAvatarLearnMore"
    :onTasksLearnMore="onTasksLearnMore"
    :showStartingPrice="false"
    :globalSelectEnable="globalSelectEnable"
    :startingPrice="$money(annualPriceNum * 10)"
  />
  <FeatureULForEdu v-if="planCategory === ZOOM_MEETING_SUB_TYPES.EDUCATION" />
  <zm-button data-testid="checkout-button-153" v-if="showFullComparisonDialog" type="primary" ghost class="zone-detail-dialog__confirm-btn text-capitalize" @click="handleSure">{{ $t('billing.zone.see_full_feature') }}</zm-button>
  <p class="zone-detail-dialog__tips" v-if="[ZOOM_MEETING_SUB_TYPES.BIZ, ZOOM_MEETING_SUB_TYPES.BIZ_PLUS].includes(planCategory) && !unlockBizLicenseCount">
    *{{ $t('billing.zone.biz_details.tips', [$money(annualPriceNum * 10, { forceDiff: true })]) }}
  </p>
  <p class="zone-detail-dialog__tips" v-else-if="[ZOOM_MEETING_SUB_TYPES.EDUCATION].includes(planCategory)">
    *{{ $t('billing.zone.edu_details.tips', [20, $money(annualPriceNum * 20, { forceDiff: true })]) }}
  </p>
</zm-dialog>
</template>
<script type="text/jsx">
import ZoomOneLogo from '@/assets/plans/zoom_one.svg';
import ZoomWorkplaceLogo from '@/assets/plans/zoom_workplace.svg';
import ZoomWorkplaceDarkLogo from '@/assets/plans/zoom_workplace-dark.svg';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog.vue';
import NavBack from '@/components/nav-back.vue';
import { mapState, mapGetters } from 'vuex';
import { BILLING_CYCLE, INDUSTRIES, planTypes, unlockBizLicenseCount, BADGE_ID_MAPPER, CMR_STORAGE_FOR_MEETING_PLAN, BASE_PLAN_SUB_TYPES } from '@/common/constants';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { getCategoryNameI18nKey, getTitleNameI18nKey, ZOOM_MEETING_SUB_TYPES } from '../common/utils';
import {getCurrency, getCurrencySymbol} from "@/utils/currency";
import AICompanionLearnMoreDialog from '@/components/full-comparison-table/ai-companion-learn-more-dialog.vue';
import VisitorManagementLearnMoreDialog from '@/components/full-comparison-table/visitor-management-learn-more-dialog.vue';
import TasksLearnMoreDialog from '@/components/full-comparison-table/tasks-learn-more-dialog.vue';
import CustomAvatarLearnMoreDialog from '@/components/full-comparison-table/custom-avatar-learn-more-dialog.vue';
import SparklesIcon from '@/assets/plans/sparkle-new.svg';
import { plansof } from '@/utils/chain';
import PriceList from "@/components/price-list.vue";
import { planUnitMap } from '@/common/product-unit';
import { isProPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import { translateToEn, translation } from '@/plugins/i18n';
import { pageConfig } from '@/common/service/page-config';
import { THEME } from '@/views/checkout/constant.js';
import { get } from 'lodash';
import { zoneBundleMode, ZONE_BUNDLE_MODE } from '@/plans/ZOOM_ONE_BUNDLE/helper';
import planFeaturesMixin from '@/utils/planFeaturesMixin';
import { isEnableEssentialApps } from '@/utils/toggle'
import { AUTO_EXPIRE_BADGE as AutoExpireBadge } from '@zoom/billing-shared';
import mxSoftBundleMeeting from '@/plans/ZOOM_MEETING/mixin/soft-bundle-meeting';

const planTypeMap = {[ZOOM_MEETING_SUB_TYPES.BIZ_PLUS]: planTypes.ZOOM_ONE_BUNDLE, [ZOOM_MEETING_SUB_TYPES.PRO_PLUS]: planTypes.ZONE_PRO_PLUS};

const FeatureForDocs = {
  functional: true,
  render() {
    return (
      <li class="zone-detail-dialog__feature-item docs-item">
        <h2 class="zone-detail-dialog__feature-title first-capitalize">
          { translation('billing.docs.docs') }
        </h2>
        <ul class="zone-detail-dialog__feature-item-list">
          <li>{ translation('billing.docs.features_item1') }</li>
          <li>{ translation('billing.docs.features_item2') }</li>
          <li>{ translation('billing.docs.features_item3') }</li>
        </ul>
      </li>
    )
  }
}

const FeatureForTasks = {
  functional: true,
  name: 'Tasks',
  props: {
    learnMore: Element
  },
  render(h, context) {
    return (
      <li class="zone-detail-dialog__feature-item tasks-item">
        <h2 class="zone-detail-dialog__feature-title first-capitalize">
          <AutoExpireBadge badgeId={BADGE_ID_MAPPER.TASKS} class="zone-detail-dialog__new-label" />
          { translation('billing.tasks.tasks') }
        </h2>
        <ul class="zone-detail-dialog__feature-item-list ">
          <li>{ translation('billing.tasks.features_item1') }</li>
          <li>{ translation('billing.tasks.features_item2') }<br/>
            {context.props.learnMore}
          </li>
        </ul>
      </li>
    )
  }
}

const FeatureForZoomWorkFlow = {
  functional: true,
  props: {
    learnMore: Element
  },
  render(h, context) {
    return (
      <li class="zone-detail-dialog__feature-item tasks-item">
        <h2 class="zone-detail-dialog__feature-title first-capitalize">
          <AutoExpireBadge badgeId={BADGE_ID_MAPPER.WORKFLOW_AUTOMATION} class="zone-detail-dialog__new-label" />
          { translation('billing.plan_feature.workflow.title') }
        </h2>
        <ul class="zone-detail-dialog__feature-item-list ">
          <li>{ translation('billing.plan_feature.workflow.desc_ai') }</li>
          <li>{ translation('billing.plan_feature.workflow.desc_doc') }<br/>
            {context.props.learnMore}
          </li>
        </ul>
      </li>
    )
  }
}

const FeatureForDrive = {
  functional: true,
  props: {
    learnMore: Element
  },
  render(h, context) {
    return (
      <li class="zone-detail-dialog__feature-item tasks-item">
        <h2 class="zone-detail-dialog__feature-title first-capitalize">
          <AutoExpireBadge badgeId={BADGE_ID_MAPPER.DRIVE} class="zone-detail-dialog__new-label" />
          { translation('billing.plan_feature.drive.title') }
        </h2>
        <ul class="zone-detail-dialog__feature-item-list ">
          <li>{ translation('billing.plan_feature.drive.feature1') }</li>
          <li>{ translation('billing.plan_feature.drive.feature2') }</li>
          <li>{ translation('billing.plan_feature.drive.feature3') }<br/>
            {context.props.learnMore}
          </li>
        </ul>
      </li>
    )
  }
}

const FeatureForCustomAvatar = {
  functional: true,
  props: {
    learnMore: Element
  },
  render(h, context) {
    return (
      <li class="zone-detail-dialog__feature-item tasks-item">
        <h2 class="zone-detail-dialog__feature-title first-capitalize">
          <AutoExpireBadge badgeId={BADGE_ID_MAPPER.CUSTOM_AVATAR} class="zone-detail-dialog__new-label" />
          { translation('billing.custom_avatars.title') }
        </h2>
        <ul class="zone-detail-dialog__feature-item-list ">
          <li>{ translation('billing.custom_avatars.features_item1') }</li>
          <li>{ translation('billing.custom_avatars.features_item2') }<br/>
            {context.props.learnMore}
          </li>
        </ul>
      </li>
    )
  }
}
const FeatureForEssentialApps = {
  functional: true,
  name: 'EssentialApp',
  render(h, context) {
    return (
      <li class="zone-detail-dialog__feature-item">
        <h2 class="zone-detail-dialog__feature-title first-capitalize">{translation('billing.essential_apps')}</h2>
        <ul class="zone-detail-dialog__feature-item-list">
          <li>{translation('billing.zone.pro_details.row8')}</li>
          <li>
            {translation('billing.zone.pro_details.row9')}<br/>
            <zm-button data-testid="checkout-button-155" type="link" class="zone-detail-dialog__link" onClick={context.listeners.learnMoreClick} aria-label="Learn More about Essential Apps">{translation('billing.common.Learn_More')}</zm-button>
          </li>
        </ul>
      </li>
    )
  }
}

const FeatureULForPro = {
  props: {
    onEssentialAppLearnMore: Function,
    onAICompanionLearnMore: Function,
    onTasksLearnMore: Function,
    onWorkFlowLearnMore: Function,
    onDriveLearnMore: Function,
    onCustomAvatarLearnMore: Function
  },
  render() {
    const enableLiveChatSupport = get(window.campaignFlags, 'enableLiveChatSupport', false);
    const enableEssentialApps = isEnableEssentialApps();
    return (
      <ul class="zone-detail-dialog__feature">
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.zone.meetings')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.pro_details.row1')}</li>
            <li>{this.$t('billing.zone.pro_details.row2')}</li>
            <li>
              {this.$t('billing.zone.pro_details.row3', { capacity: CMR_STORAGE_FOR_MEETING_PLAN[BASE_PLAN_SUB_TYPES.PRO] })}
            </li>
            <li>{this.$t('billing.zone.pro_details.row4')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.whiteboard_basic')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.pro_details.row5')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.team_chat')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.pro_details.row6')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            {this.$t('billing.mail_calendar')}
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.mail_calendar.row1')}</li>
          </ul>
        </li>
        {
          !window.newBillingConfig.disabledClips && (
            <li class="zone-detail-dialog__feature-item">
              <h2 class="zone-detail-dialog__feature-title first-capitalize">
                { this.$t('billing.clips_plus') }
              </h2>
              <ul class="zone-detail-dialog__feature-item-list">
                <li>{ this.$t('billing.zone.biz_details.clips.row1') }</li>
                <li>{ this.$t('billing.zone.biz_details.clips.row2') }</li>
              </ul>
            </li>
          )
        }
        {window.newBillingConfig.isEligibleAccount4CustomAvatarFeature && <FeatureForCustomAvatar />}
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            { this.$t('billing.notes') }
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{ this.$t('billing.zone.biz_details.notes.row1') }</li>
            <li>{ this.$t('billing.zone.biz_details.notes.row2') }</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item ai-companion-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            { this.$t('billing.ai_companion') }
            <img src={SparklesIcon} class="zone-detail-dialog__feature-title__icon" />
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{ this.$t('billing.zone.biz_details.ai_companion.row1_new') }</li>
            <li>
              { this.$t('billing.zone.biz_details.ai_companion.row2') }<br/>
              <zm-button data-testid="checkout-button-154" type="link" class="zone-detail-dialog__link" onClick={this.onAICompanionLearnMore} aria-label="Learn More about AI Companion">{this.$t('billing.common.Learn_More')}</zm-button>
            </li>
          </ul>
        </li>
        { window.newBillingConfig.enableDocsFeature && <FeatureForDocs /> }
        { enableEssentialApps && <FeatureForEssentialApps onLearnMoreClick={this.onEssentialAppLearnMore} /> }
        {window.newBillingConfig.enableDisplayZoomTasksWithoutAccountCheck && <FeatureForTasks
          learnMore={<zm-button data-testid="checkout-button-156" type="link" class="zone-detail-dialog__link" onClick={this.onTasksLearnMore}
                                aria-label="Learn More about Zoom Tasks">{this.$t('billing.common.Learn_More')}</zm-button>} />}
        {window.newBillingConfig.enableDisplayZoomWorkFlow && <FeatureForZoomWorkFlow
          learnMore={<zm-button data-testid="checkout-button-156" type="link" class="zone-detail-dialog__link" onClick={this.onWorkFlowLearnMore}
                                aria-label="Learn More about Zoom WorkFlow">{this.$t('billing.common.Learn_More')}</zm-button>} />}
        {window.newBillingConfig.enableDisplayZoomDrive && <FeatureForDrive
          learnMore={<zm-button data-testid="checkout-button-156" type="link" class="zone-detail-dialog__link" onClick={this.onDriveLearnMore}
                                aria-label="Learn More about Zoom Hub">{this.$t('billing.common.Learn_More')}</zm-button>} />}
        {enableLiveChatSupport && <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.live_support')}</h2>
        </li>}
      </ul>
    )
  },
};

const FeatureULForBiz = {
  props: {
    onEssentialAppLearnMore: Function,
    onAICompanionLearnMore: Function,
    isEnableBizPriceIncrease: Boolean,
    onTasksLearnMore: Function,
    onWorkFlowLearnMore: Function,
    onDriveLearnMore: Function,
    onCustomAvatarLearnMore: Function,
  },
  render() {
    const enableEssentialApps = isEnableEssentialApps()
    return (
      <ul class="zone-detail-dialog__feature">
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.zone.meetings')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.meetings.row1')}</li>
            <li>{this.$t('billing.zone.biz_details.meetings.row2')}</li>
            <li>
              {this.$t('billing.zone.biz_details.meetings.row3', { capacity: CMR_STORAGE_FOR_MEETING_PLAN[BASE_PLAN_SUB_TYPES.BIZ] })}
            </li>
            <li>{this.$t('billing.zone.biz_details.meetings.row4')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.whiteboard')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.whiteboard.row1')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.team_chat')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.team_chat.row1')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            {/* <span class="zone-detail-dialog__new-label">{this.$t('billing.common.beta')}</span> */}
            {this.$t('billing.mail_calendar')}
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.mail_calendar.row1')}</li>
          </ul>
        </li>
        {
          !window.newBillingConfig.disabledClips && (
            <li class="zone-detail-dialog__feature-item">
              <h2 class="zone-detail-dialog__feature-title first-capitalize">
                { this.$t('billing.clips_plus') }
              </h2>
              <ul class="zone-detail-dialog__feature-item-list">
                <li>{ this.$t('billing.zone.biz_details.clips.row1') }</li>
                <li>{ this.$t('billing.zone.biz_details.clips.row2') }</li>
              </ul>
            </li>
          )
        }
        { window.newBillingConfig.isEligibleAccount4CustomAvatarFeature && <FeatureForCustomAvatar />}
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            { this.$t('billing.notes') }
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{ this.$t('billing.zone.biz_details.notes.row1') }</li>
            <li>{ this.$t('billing.zone.biz_details.notes.row2') }</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item ai-companion-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            { this.$t('billing.ai_companion') }
            <img src={SparklesIcon} class="zone-detail-dialog__feature-title__icon" />
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{ this.$t('billing.zone.biz_details.ai_companion.row1_new') }</li>
            <li>
              { this.$t('billing.zone.biz_details.ai_companion.row2') }<br/>
              <zm-button data-testid="checkout-button-157" type="link" class="zone-detail-dialog__link" onClick={this.onAICompanionLearnMore} aria-label="Learn More about AI Companion">{this.$t('billing.common.Learn_More')}</zm-button>
            </li>
          </ul>
        </li>
        { window.newBillingConfig.enableDocsFeature && <FeatureForDocs /> }
        { enableEssentialApps && <FeatureForEssentialApps onLearnMoreClick={this.onEssentialAppLearnMore} /> }
        { window.newBillingConfig.enableDisplayZoomTasksWithoutAccountCheck && <FeatureForTasks learnMore={<zm-button data-testid="checkout-button-159" type="link" class="zone-detail-dialog__link" onClick={this.onTasksLearnMore} aria-label="Learn More about Zoom Tasks">{ this.$t('billing.common.Learn_More') }</zm-button>} />}
        {window.newBillingConfig.enableDisplayZoomWorkFlow && <FeatureForZoomWorkFlow
          learnMore={<zm-button data-testid="checkout-button-156" type="link" class="zone-detail-dialog__link" onClick={this.onWorkFlowLearnMore}
                                aria-label="Learn More about Zoom WorkFlow">{this.$t('billing.common.Learn_More')}</zm-button>} />}
        {window.newBillingConfig.enableDisplayZoomDrive && <FeatureForDrive
          learnMore={<zm-button data-testid="checkout-button-156" type="link" class="zone-detail-dialog__link" onClick={this.onDriveLearnMore}
                                aria-label="Learn More about Zoom Hub">{this.$t('billing.common.Learn_More')}</zm-button>} />}
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.extras')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.extras.row1')}</li>
            <li>{this.$t('billing.zone.biz_details.extras.row2')}</li>
            <li>{this.$t('billing.zone.biz_details.extras.row3')}</li>
          </ul>
        </li>
        {!!this.isEnableBizPriceIncrease && (<li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            {this.$t('billing.scheduler.short_title')}
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.scheduler.feature_details.item1')}</li>
            <li>{this.$t('billing.scheduler.feature_details.item2')}</li>
          </ul>
        </li>)}
      </ul>
    )
  },
}

const FeatureULForEdu = {
  data() {
    return {
      details: [{
        title: 'billing.zone.edu.hd',
        sub: 'billing.zone.edu_details.hd'
      },{
        title: 'billing.zone.meetings',
        sub: 'billing.zone.edu_details.meetings'
      },{
        title: 'billing.zone.edu.attendees',
        sub: 'billing.zone.edu_details.attendees'
      },{
        title: 'billing.zone.edu.wb',
        sub: 'meetings.unlimited'
      },{
        title: 'billing.zone.edu.team_chat',
        sub: ''
      },{
        title: 'billing.zone.edu.MC',
        sub: ''
      },{
        title: 'cloudStorage',
        sub: 'billing.zone.edu_details.cloud_storage'
      }]
    }
  },
  render() {
    return (
      <ul class="zone-detail-dialog__feature z-edu-feature">
        {
          this.details.map(detail => (<li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize z-edu-feature-title">
            {this.$t(detail.title)}
          </h2>
          <span class="zone-detail-dialog__feature-sub" v-if="detail.sub">{this.$t(detail.sub)}</span>
        </li>))
        }
      </ul>
    )
  },
}

export default {
  name: 'PlanDetails',
  mixins: [ConfirmComponent, planFeaturesMixin, mxSoftBundleMeeting],
  components: {
    PriceList,
    FeatureULForBiz,
    FeatureULForPro,
    FeatureULForEdu,
    NavBack,
  },
  props: {
    planCategory: String,
    hideComparisonTable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      currencySymbol: getCurrencySymbol(getCurrency()),
      essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog, this.$store),
      aiCompanionLearnMoreDialogService: new ServiceConfirm(AICompanionLearnMoreDialog),
      visitorManagementLearnMoreDialogService: new ServiceConfirm(VisitorManagementLearnMoreDialog),
      tasksLearnMoreDialogService: new ServiceConfirm(TasksLearnMoreDialog),
      customAvatarLearnMoreDialogService: new ServiceConfirm(CustomAvatarLearnMoreDialog),
      planUnitMap,
      ZOOM_MEETING_SUB_TYPES: Object.freeze(ZOOM_MEETING_SUB_TYPES),
      globalSelectEnable: zoneBundleMode.mode !== ZONE_BUNDLE_MODE.NO_GLOBAL
    };
  },
  methods: {
    async onEssentialAppLearnMore () {
      this.$tracking.buyInteraction('product details', `${this.isHealthcareHost ? `${translateToEn(getTitleNameI18nKey(this.planCategory))} ${INDUSTRIES.HEALTHCARE} ` : ''}plan details - learn more`);
      await this.essentialAppLearnMoreDialogService.confirm();
    },
    async onAICompanionLearnMore() {
      this.$tracking.buyInteraction('product details', `${this.isHealthcareHost ? `${translateToEn(getTitleNameI18nKey(this.planCategory))} ${INDUSTRIES.HEALTHCARE} ` : ''}plan details - learn more`);
      await this.aiCompanionLearnMoreDialogService.confirm();
    },
    async onTasksLearnMore() {
      this.$tracking.buyInteraction('product details', `${this.isHealthcareHost ? `${translateToEn(getTitleNameI18nKey(this.planCategory))} ${INDUSTRIES.HEALTHCARE} ` : ''}plan details - learn more`);
      await this.tasksLearnMoreDialogService.confirm();
    },
    async onWorkFlowLearnMore() {
      this.$tracking.buyInteraction('product details', `${this.isHealthcareHost ? `${translateToEn(getTitleNameI18nKey(this.planCategory))} ${INDUSTRIES.HEALTHCARE} ` : ''}plan details - learn more`);
      await this.openDialogInCommon(this.featureKeys.zoomWorkFlowAutomation);
    },
    async onDriveLearnMore() {
      this.$tracking.buyInteraction('product details', `${this.isHealthcareHost ? `${translateToEn(getTitleNameI18nKey(this.planCategory))} ${INDUSTRIES.HEALTHCARE} ` : ''}plan details - learn more`);
      this.openPlanLearnMoreDialog(planTypes.DRIVE, { buttonComponent: () => null });
    },
    async onVisitorManagementLearnMore() {
      this.$tracking.buyInteraction('product details', `${this.isHealthcareHost ? `${translateToEn(getTitleNameI18nKey(this.planCategory))} ${INDUSTRIES.HEALTHCARE} ` : ''}plan details - learn more`);
      await this.visitorManagementLearnMoreDialogService.confirm();
    },
    async onCustomAvatarLearnMore() {
      this.$tracking.buyInteraction('product details', `${this.isHealthcareHost ? `${translateToEn(getTitleNameI18nKey(this.planCategory))} ${INDUSTRIES.HEALTHCARE} ` : ''}plan details - learn more`);
      await this.customAvatarLearnMoreDialogService.confirm();
    },
    handleSure() {
      this.$tracking.buyInteraction('product details', `${this.isHealthcareHost ? `${translateToEn(getTitleNameI18nKey(this.planCategory))} ${INDUSTRIES.HEALTHCARE} ` : ''}plan details - see full feature list`);
    },
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['enableBizPriceIncrease', 'healthcareAvailable', 'clientWebViewTheme', 'getSelectedPlans']),
    showFullComparisonDialog() {
      if (this.soft_bundle_hiddenSwitchCategoryEntry) return false;
      if (this.hideComparisonTable) return false;
      if (this.$context.is.buyTrial || this.$context.is.add2trial) return false;
      if (this.planCategory === ZOOM_MEETING_SUB_TYPES.EDUCATION) return false;
      return true;
    },
    isIframesModal() {
      return this.$context.is.modal;
    },
    isHealthcareHost() {
      return this.healthcareAvailable && this.planCategory === ZOOM_MEETING_SUB_TYPES.PRO
    },
    isEnableBizPriceIncrease() {
      return this.enableBizPriceIncrease;
    },
    logo() {
      const isWorkplace = pageConfig.isZoomWorkplaceRebranding || isProPlusContext;
      return isWorkplace
        ? (this.clientWebViewTheme === THEME.DARK
          ? ZoomWorkplaceDarkLogo
          : ZoomWorkplaceLogo)
        : ZoomOneLogo;
    },
    annualPriceNum () {
      if([ZOOM_MEETING_SUB_TYPES.BIZ_PLUS, ZOOM_MEETING_SUB_TYPES.PRO_PLUS].includes(this.planCategory)){
        const zoneBundlePlans = plansof(this.planMapFlat).type(planTypeMap[this.planCategory]).annual();
        const category0 = zoneBundlePlans.clone().get(0)?.category; // HACK only get first of regions
        return zoneBundlePlans.category(category0).sum('price');
      };
      let annualPlan = this.planMapFlat.find(plan => plan.category === this.planCategory && plan.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (annualPlan) {
        return annualPlan.amount;
      }
      return 0;
    },
    annualPrice () {
      return (this.annualPriceNum / 100).toFixed(2);
    },
    monthlyPriceNum () {
      if([ZOOM_MEETING_SUB_TYPES.PRO_PLUS, ZOOM_MEETING_SUB_TYPES.BIZ_PLUS].includes(this.planCategory)){
        const zoneBundlePlans = plansof(this.planMapFlat).type(planTypeMap[this.planCategory]).monthly();
        const category0 = zoneBundlePlans.clone().get(0)?.category; // HACK only get first of regions
        return zoneBundlePlans.category(category0).sum('price')
      };
      let monthlyPlan = this.planMapFlat.find(plan => plan.category === this.planCategory && plan.billing_cycle === BILLING_CYCLE.MONTHLY);
      if (monthlyPlan) {
        return monthlyPlan.amount;
      }
      return 0;
    },
    monthlyPrice () {
      return (this.monthlyPriceNum / 100).toFixed(2);
    },
    planCategoryName() {
      return this.$t(getCategoryNameI18nKey(this.planCategory));
    },
    defaultPlanCategory() {
      if (ZOOM_MEETING_SUB_TYPES.BIZ_PLUS === this.planCategory) {
        const _category = plansof(this.getSelectedPlans).type(planTypes.ZOOM_ONE_BUNDLE).get(0)?.category;
        return _category || plansof(this.planMapFlat).type(planTypes.ZOOM_ONE_BUNDLE).get(0)?.category;
      }

      if (ZOOM_MEETING_SUB_TYPES.PRO_PLUS === this.planCategory) {
        return plansof(this.planMapFlat).type(planTypes.ZONE_PRO_PLUS).get(0)?.category;
      }

      return this.planCategory;
    },
    unlockBizLicenseCount() {
      return unlockBizLicenseCount;
    },
  },
  watch: {
    visible: {
      handler(newVal, oldVal) {
        const prefix = this.$t('billing.planform.title.zoom_meeting_zoomonenew');

        if (oldVal && !newVal) {
          if (this.$context.is.edu) {
            this.$tracking.buyInteraction('product details', `${this.planCategoryName} plan details - exit`);
          } else {
            this.$tracking.buyInteraction('product details', `${prefix} ${this.planCategoryName}${this.isHealthcareHost ? ` ${INDUSTRIES.HEALTHCARE}` : ''} plan details - exit`);
          }
        }

        if (newVal) {
          if (this.$context.is.edu) {
            this.$tracking.buyInteraction('product details', `${this.planCategoryName} plan details - impression`);
          } else {
            this.$tracking.buyInteraction('product details', `${prefix} ${this.planCategoryName}${this.isHealthcareHost ? ` ${INDUSTRIES.HEALTHCARE}` : ''} plan details - impression`);
          }
          // keep items ul's width same as price's width
          this.$nextTick(() => {
            const adjustWidth = document.querySelector('.zone-detail-dialog .zone-detail-dialog__price')?.offsetWidth ?? 0;
            const itemULDom = document.querySelector('.zone-detail-dialog .zone-detail-dialog__feature');
            if (itemULDom && adjustWidth > 400) {
              itemULDom.style.width = adjustWidth + 'px';
            }
          });
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.zone-detail-dialog {
  // override global style in nav-top-assets css in modal dialog
  &.opc-modal-dialog {
    .zm-dialog {
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      height: 100%;
      max-width: 100%;
      border-radius: 0;
      overflow: auto;
      scrollbar-width: none;
      @include media(tablet) {
        padding: 32px !important;
      }
      .zm-dialog__body {
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .mb24 {
          margin-bottom: 24px;
        }
      }
      .zm-dialog__header {
        padding: 0;
        margin-bottom: 8px;
        .zm-dialog__headerbtn {
          position: absolute;
          top: 16px;
          right: 16px;
        }
      }
    }

  }
  .zm-dialog {
    min-width: 522px;
    padding: 70px 60px;
    width: fit-content;
  }
  &__title {
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 150%;
    color: #515079;
    &.zone-text-upper {
      text-transform: uppercase;
    }
  }
  &__price {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
    @include media(mobile, tablet) {
      margin-bottom: 0;
      padding: 16px 0;
    }

    p.price.price-component {
      // Higher priority selector to overwrite the default style
      flex-wrap: nowrap;
      @include media(mobile, tablet) {
        flex-wrap: wrap;
      }
    }

    &-item {
      flex: 1;
      padding-right: 24px;
      padding-left: 0;
      display: flex;
      align-items: flex-start;

      .price__currency {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__int {
        font-family: $happy-display;
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 48px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__decimal {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__unit {
        font-style: normal;
        font-weight: 450;
        font-size: 16px;
        line-height: 38px;
        color: #00053D;
        align-self: flex-end;
      }
      &+& {
        padding-right: 0;
        padding-left: 24px;
        border-left: 2px solid #B8B8C4;
      }
    }

  }
  &__feature {
    width: 400px;
    @include media(mobile, tablet) {
      width: 100%;
    }
    &-title {
      color: #00053D;
      font-family: Almaden Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 21px */
      letter-spacing: 0.14px;
      display: flex;
      flex-direction: row;
      align-items: center;
      &__icon {
        width: 16px;
        height: 16px;
        font-size: 0;
        margin-left: 4px;
      }
    }
    &.z-edu-feature {
      h2.z-edu-feature-title {
        display: inline-block;
      }
    }
    &-sub {
      color: #666487;
      font-family: "Almaden Sans";
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 150%;
      letter-spacing: 0.12px;
      margin-left: 0.5em;
    }
    &-item {
      position: relative;
      padding-left: 20px;
      margin-bottom: 16px;
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        background-image: url('../../../assets/Vector.svg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 16px;
        height: 21px;
        font-size: 20px;
        font-weight: 700;
      }
      &-list {
        list-style: disc;
        padding-left: 14px;
        li {
          &::marker {
            color: #00053D;
          }
          &::first-letter {
            text-transform: capitalize;
          }
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 150%;
          color: #00053D;
        }
      }
    }
  }
  &__link.zm-button--link {
    font-style: normal;
    font-weight: 450;
    font-size: 12px;
    line-height: 150%;
    padding: 0;
  }
  &__confirm-btn.zm-button {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 120%;
    color: #0B5CFF;
    padding: 0;
    margin: 4px;
  }
  &__new-label.auto-expire-badge {
    color: #0b5cff;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    background: #F2F2F4;
    padding: 0 6px;
    margin-right: 4px;
  }
  &__tips {
    margin: 0;
    margin-top: 16px;
    padding: 8px 12px;
    background: #F2F2F4;
    border-radius: 8px;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #515079;
    @include media(mobile) {
      margin-top: 16px;
      font-size: 12px;
    }
  }

}

.zm-theme--dark {
  .zone-detail-dialog__title {
    color: $dark-text-color2;
  }
}
</style>
